<template>
    <div class="works-picture">
        <div class="works border-bottom">
            <div class="works-wrapper border-right upload-logo">
                <div class="upload-logo-box">
                    <div class="upload-works-detail">
                      <img :src="images.logoImg">
                    </div>
                    <div class="upload-logo-file" v-show="!images.logoUploaded">
                        <span>选取<br/>图片</span>
                    </div>
                    <div class="upload-mask" v-show="isEdited && !images.logoUploading" style="padding-top: 15px">
                        <img src="../../../../images/personal_center/icon-img.png">
                    </div>
                    <div class="mask-loading" v-show="images.logoUploading">
                      <div class="loading-box">
                        <div class="loading">
                          <div class="strip1 strip"></div>
                          <div class="strip2 strip"></div>
                          <div class="strip3 strip"></div>
                          <div class="strip4 strip"></div>
                          <div class="strip5 strip"></div>
                          <div class="strip6 strip"></div>
                          <div class="strip7 strip"></div>
                          <div class="strip8 strip"></div>
                          <div class="strip9 strip"></div>
                          <div class="strip10 strip"></div>
                          <div class="strip11 strip"></div>
                          <div class="strip12 strip"></div>
                        </div>
                      </div>
                    </div>
                    <input type="file" name="logo" value="" accept="image/*" @change="imgOnChange($event, 'logo')" title="更换图片">
                </div>
                <h2>上传作品LOGO</h2>
                <p>图片尺寸：88 x 88px </p>
                <p>图片格式：JPG / PNG </p>
                <p>图片用途：图片将用于展示在用的蓝鲸平台的桌面上，以及开发者中心的APP LOGO中。</p>
            </div>
            <div class="works-wrapper">
                <div class="product-img" @mouseenter="showCover" @mouseleave="hideCover">
                    <div class="upload-works-detail">
                        <img :src="images.coverImg">
                        <i class="bk-icon icon-error" v-show="images.coverIndex === 1" v-if="images.coverObj" @click="closeImg($event, 'cover')"></i>
                        <span class="text" v-show="images.coverIndex === 1" v-if="images.coverObj">{{images.coverObj.name}}</span>
                    </div>
                    <div class="mask" v-show="!images.coverUploaded">
                        <div class="mask-box">
                            <img src="../../../../images/personal_center/icon-img-gray.png">
                            <div class="text">
                                上传作品封面
                            </div>
                        </div>
                    </div>
                    <div class="upload-mask" v-show="isEdited && !images.coverUploading">
                      <img src="../../../../images/personal_center/icon-img.png">
                      <div class="text">
                        修改封面图片
                      </div>
                    </div>
                    <div class="mask-loading" v-show="images.coverUploading">
                        <div class="loading-box">
                            <div class="loading">
                                <div class="strip1 strip"></div>
                                <div class="strip2 strip"></div>
                                <div class="strip3 strip"></div>
                                <div class="strip4 strip"></div>
                                <div class="strip5 strip"></div>
                                <div class="strip6 strip"></div>
                                <div class="strip7 strip"></div>
                                <div class="strip8 strip"></div>
                                <div class="strip9 strip"></div>
                                <div class="strip10 strip"></div>
                                <div class="strip11 strip"></div>
                                <div class="strip12 strip"></div>
                            </div>
                            <div class="text">
                                正在上传图片...
                            </div>
                        </div>
                    </div>
                    <input type="file" name="cover" value="" accept="image/*" @change="imgOnChange($event, 'cover')" title="更换图片">
                </div>
                <div class="artwork-cover">
                    <h2>上传作品封面</h2>
                    <p>图片像素：285 x 160px </p>
                    <p>图片格式：JPG / PNG </p>
                    <p>图片用途：图片将用于官方首页或应用分类页的展示，精美的LOGO图可以大幅度提升作品对用户的注意力和吸引力，建议您精心挑选...</p>
                </div>
            </div>
        </div>
        <div class="works">
            <div class="works-wrapper upload-works">
                <ul class="upload-works-list">
                    <li v-for="(item, index) in workList"
                     @mouseenter="showCurWorks(item, index)"
                     @mouseleave="hideCurWorks">
                        <div class="upload-works-detail">
                            <img :src="images[item.obj+'Img']">
                            <i class="bk-icon icon-error" v-show="index === images.avatarIndex" v-if="images[item.obj+'Obj']" @click="closeImg($event, item.obj)"></i>
                            <span class="text" v-show="index === images.avatarIndex" v-if="images[item.obj+'Obj']">{{images[item.obj+'Obj'].name}}</span>
                        </div>
                        <div class="mask" v-show="!images[item.obj+'Img']">
                            <div class="mask-box">
                                <img src="../../../../images/personal_center/icon-img-gray.png">
                                <div class="text">
                                    上传作品截图
                                </div>
                            </div>
                        </div>
                        <div class="upload-mask" v-show="isEdited && !images[item.obj+'Uploading']">
                          <img src="../../../../images/personal_center/icon-img.png">
                          <div class="text">
                            修改截图图片
                          </div>
                        </div>
                        <div class="mask-loading" v-show="images[item.obj+'Uploading']">
                            <div class="loading-box">
                                <div class="loading">
                                    <div class="strip1 strip"></div>
                                    <div class="strip2 strip"></div>
                                    <div class="strip3 strip"></div>
                                    <div class="strip4 strip"></div>
                                    <div class="strip5 strip"></div>
                                    <div class="strip6 strip"></div>
                                    <div class="strip7 strip"></div>
                                    <div class="strip8 strip"></div>
                                    <div class="strip9 strip"></div>
                                    <div class="strip10 strip"></div>
                                    <div class="strip11 strip"></div>
                                    <div class="strip12 strip"></div>
                                </div>
                                <div class="text">
                                    正在上传图片...
                                </div>
                            </div>
                        </div>
                        <input type="file" name="avatar" value="" accept="image/*" @change="imgOnChange($event, item.obj)" title="更换图片">
                    </li>
                </ul>
                <h2>上传作品截图</h2>
                <p>图片像素：868 x 488px </p>
                <p>图片格式：JPG / PNG </p>
                <p>图片用途：图片将用于显示在应用详情介绍页面中，目前最多仅支持上次3张；您可以上次应用系统的页面截图，亦或者产品宣传图片皆可。一张富有说服力的应用介绍图片能够帮助用户更快的了解你的作品，请务必要谨慎筛选。</p>
            </div>
        </div>
        <!-- 弹窗 -->
        <div class="personal-pops" v-show="images.isShowImageEditor">
            <div class="pops-content">
                <h4>
                    {{ images.editImageTitle }}剪裁
                    <a class="fr pops-close" href="javascript:;" @click="closeImageEditor">
                        <img src="../../../../images/personal_center/pops-close.png" alt="" />
                    </a>
                </h4>
                <div class="editor">
                    <img :src="images.imageWaitingForCrop" alt="" id="editor">
                </div>
                <div class="btn-row">
                    <div class="fl">
                        <a type="button" class="btn" data-type="controller" data-method="zoom" data-options="0.1" title="放大">
                            <span class="docs-tooltip">
                                <span class="glyphicon glyphicon-zoom-in" aria-hidden="true"></span>
                            </span>
                        </a>
                        <a type="button" class="btn" data-type="controller" data-method="zoom" data-options="-0.1" title="缩小">
                            <span class="docs-tooltip">
                                <span class="glyphicon glyphicon-zoom-out" aria-hidden="true"></span>
                            </span>
                        </a>
                        <a type="button" class="btn" data-type="controller" data-method="move" data-options="-10" data-second-options="0" title="左移">
                            <span class="docs-tooltip">
                                <span class="glyphicon glyphicon-arrow-left" aria-hidden="true"></span>
                            </span>
                        </a>
                        <a type="button" class="btn" data-type="controller" data-method="move" data-options="10" data-second-options="0" title="右移">
                            <span class="docs-tooltip">
                                <span class="glyphicon glyphicon-arrow-right" aria-hidden="true"></span>
                            </span>
                        </a>
                        <a type="button" class="btn" data-type="controller" data-method="move" data-options="0" data-second-options="-10" title="上移">
                            <span class="docs-tooltip">
                                <span class="glyphicon glyphicon-arrow-up" aria-hidden="true"></span>
                            </span>
                        </a>
                        <a type="button" class="btn" data-type="controller" data-method="move" data-options="0" data-second-options="10" title="下移">
                            <span class="docs-tooltip">
                                <span class="glyphicon glyphicon-arrow-down" aria-hidden="true"></span>
                            </span>
                        </a>
                    </div>
                    <button type="button" name="button" class="confirm-image-editor" @click="confirmCrop">确定</button>
                </div>
            </div>
        </div>
        <!-- 弹出框子组件 -->
        <v-alert :options="options"></v-alert>
    </div>
</template>

<script type="text/javascript">
    import vAlert from '../../../alert.vue'
    import Cropper from 'cropperjs'
    export default {
        components: {
            vAlert
        },
        props: {
            isEdited: {
                type: Boolean,
                type: false
            },
            logoImg: {
                type: String,
                default: ''
            },
            coverImg: {
                type: String,
                default: ''
            },
            previewImg: {
                type: Array,
                default () {
                    return ['', '', '']
                }
            }
        },
        watch: {
            logoImg (url) {
                this.images.logoImg = url
                this.images.logoUploaded = true
            },
            coverImg (url) {
                this.images.coverImg = url
                this.images.coverUploaded = true
            },
            previewImg (urls) {
                this.images.firstAvatarImg = urls[0]
                this.images.firstAvatarUploaded = true

                this.images.secondAvatarImg = urls[1]
                this.images.secondAvatarUploaded = true

                this.images.thirdAvatarImg = urls[2]
                this.images.thirdAvatarUploaded = true
            }
        },
        data () {
            return {
                options: {
                    msgText: "",
                    msgIsSuccess: true
                },
                images: {                   //图片剪裁相关配置
                    logoImg: this.logoImg,            //logo地址
                    logoImgId: '',          //logo地址id
                    logoObj: null,          //选中的logo
                    logoBtn: null,          //选择logo的按钮
                    logoUploading: false,   //logo上传loading
                    logoUploaded: false,    //logo是否已上传
                    coverIndex: -1,
                    coverImg: this.coverImg,           //封面图片地址
                    coverImgId: '',         //封面图片地址id
                    coverObj: null,         //选中的封面
                    coverBtn: null,         //选择封面的按钮
                    coverUploading: false,  //封面上传loading
                    coverUploaded: false,   //封面是否已上传
                    firstAvatarImg: this.previewImg[0],
                    firstAvatarImgId: '',
                    firstAvatarObj: null,
                    firstAvatarBtn: null,
                    firstAvatarUploading: false, //截图上传loading
                    firstAvatarUploaded: false,  //截图是否已上传
                    secondAvatarImg: this.previewImg[1],
                    secondAvatarImgId: '',
                    secondAvatarObj: null,
                    secondAvatarBtn: null,
                    secondAvatarUploading: false, //截图上传loading
                    secondAvatarUploaded: false,  //截图是否已上传
                    thirdAvatarImg: this.previewImg[3],
                    thirdAvatarImgId: '',
                    thirdAvatarObj: null,
                    thirdAvatarBtn: null,
                    thirdAvatarUploading: false, //截图上传loading
                    thirdAvatarUploaded: false,  //截图是否已上传
                    avatarIndex: -1,     //截图当前索引值
                    isShowImageEditor: false,
                    editImageTitle: '',
                    editImageType: '',      //当前裁剪的类型，封面or头像
                    imageWaitingForCrop: '',
                    cropper: null           //裁剪图片插件对象
                },
                isShow: false,
                // workList: ['1', '2', '3']
                workList: [{
                  obj: 'firstAvatar'
                }, {
                  obj: 'secondAvatar'
                }, {
                  obj: 'thirdAvatar'
                }]
            }
        },
        methods: {
            /*
            ** 显示当前作品信息
            */
            showCurWorks (item, index) {
              this.images.avatarIndex = index
            },
            showCover () {
              this.images.coverIndex = 1;
            },
            /*
            ** 隐藏所有鼠标经过效果
            */
            hideCurWorks () {
              this.images.avatarIndex = -1
            },
            hideCover () {
              this.images.coverIndex = -1
            },
            /*
            ** 封面图片选择后回调
            */
            imgOnChange(e, type) {
                let images = this.images,
                    target = e.target,
                    btnType = type + 'Btn',
                    objType = type + 'Obj';

                images.editImageType = type;
                images.isShowImageEditor = true;
                images[btnType] = target;

                if (target.files) {
                    images[objType] = target.files[0];
                    images.imageWaitingForCrop = this._createLocalURL(images[objType]);
                }
                else {
                    target.select();
                    images.imageWaitingForCrop = document.selection.createRange().text;
                }
                if (type == 'cover') {
                    images.editImageTitle = '作品封面';
                }
                else if (type == 'firstAvatar' || type == 'secondAvatar' || type == 'thirdAvatar') {
                    images.editImageTitle = '作品截图';
                }
                else if (type == 'logo') {
                    images.editImageTitle = '作品Logo';
                }

                setTimeout(() => {
                    this.initCropper();
                }, 10);
            },
            /*
             ** 关闭图片
             */
            closeImg (e, type) {
              let images = this.images,
                  target = e.target;

              images[type + 'Img'] = '';
              images[type + 'Obj'] = null;
              images[type + 'Btn'] = null;
              images[type + 'Index'] = -1;
              images[type + 'Uploaded'] = false;
              images[type + 'Uploading'] = false;
              this.$emit('removePicture', {
                  imgId: this.images[type + 'ImgId'],
                  type: type
              });
            },
            /*
            ** 初始化Cropper
            */
            initCropper() {
                let options = {
                    cropBoxResizable: false
                }

                if (this.images.editImageType == 'logo') {
                  options.aspectRatio = 1 / 1;
                  options.minCropBoxWidth = 88;
                  options.minCropBoxHeight = 88;
                }
                else if (this.images.editImageType == 'cover') {
                  options.aspectRatio = 285 / 160;
                  options.minCropBoxWidth = 285;
                  options.minCropBoxHeight = 160;
                }
                else {
                  let offset = 2
                  options.aspectRatio = (868 * offset) / (488 * offset);
                  options.minCropBoxWidth = 868 * offset;
                  options.minCropBoxHeight = 488 * offset;
                }

                this.images.cropper = new Cropper(document.querySelector('#editor'), options);

                this._bindCropperEvents();
            },
            /*
            ** 绑定裁剪图片按钮事件绑定
            */
            _bindCropperEvents() {
                let cropper = this.images.cropper;

                $('[data-type="controller"]').each((index, item) => {
                    $(item).on('click', function () {
                        let $this = $(this);

                        cropper[$this.attr('data-method')]($this.attr('data-options'), $this.attr('data-second-options'));
                    });
                });
            },
            /*
            ** 解除绑定事件，避免下次初始化重复绑定，且this.images.cropper对象即将被销毁
            */
            _unbindCropperEvents() {
                $('[data-type="controller"]').each((index, item) => {
                    $(item).off('click');
                });
            },
            /*
             ** 关闭图片剪裁弹窗
             */
            closeImageEditor() {
                let images = this.images;

                this._unbindCropperEvents();
                this._destroyLocalURL(this.imageWaitingForCrop);
                images.isShowImageEditor = !images.isShowImageEditor;
                images[images.editImageType + 'Btn'].value = '';    //重置选中的图片
                images.cropper.destroy();
            },
            /*
            ** 创建图片本地地址
            */
            _createLocalURL(file) {
                if (window.createObjectURL) {
                    return window.createObjectURL(file);
                }
                else if (window.URL) {
                    return window.URL.createObjectURL(file);
                }
                else if (window.webkitURL.createObjectURL) {
                    return window.webkitURL.createObjectURL(file);
                }
            },
            /*
             ** 手动释放图片的本地地址
             */
            _destroyLocalURL(url) {
                if (window.revokeObjectURL) {
                    return window.revokeObjectURL(url);
                }
                else if (window.URL) {
                    return window.URL.revokeObjectURL(url);
                }
                else if (window.webkitURL.revokeObjectURL) {
                    return window.webkitURL.revokeObjectURL(url);
                }
            },
            /*
            ** 裁剪图片确定函数
            */
            confirmCrop() {
                let options = {
                    width: 0,
                    height: 0
                },
                type = this.images.editImageType,
                loading = type + 'Uploading';
                if (type == 'logo') {
                  options.width = 88;
                  options.height = 88;

                } else if (type == 'cover') {
                  options.width = 285;
                  options.height = 160;
                } else {
                  let offset = 2
                  options.width = 868 * offset;
                  options.height = 488 * offset;
                }

                this.images[type + 'Uploading'] = true;
                let result = this.images.cropper.getCroppedCanvas(options).toDataURL('image/png');
                console.log(type + 'Img');
                this.images[type + 'Img'] = result;
                this.images[type + 'Uploaded'] = true;  // 已上传
                let request = {
                        file: result,
                        file_type: '1',
                        file_name: type+'Img',
                        file_format: 'base64'
                    };

                axios.post(myUrl + 'core/product/upload/', qs.stringify(request)).then(response => {
                    let res = response.data;
                    let data = res.data;

                    this.images[type + 'Uploading'] = false;
                    if (res.result) {
                        this.images[type + 'ImgId'] = data;
                        this.images[loading] = false;
                        this.$emit('upPictureId', {
                            imgId: this.images[type + 'ImgId'],
                            type: type
                        });
                    } else {
                        // 错误提示
                        this.options = {
                            msgIsSuccess: false,
                            msgText: res.message
                        }
                    }
                }, reject => {
                    this.images[type + 'Uploading'] = false;
                });

                this.closeImageEditor();
            },
            /*
            ** 渲染图片列表
            */
            getImagesList() {
                const app_id = this.$route.params.wid;
                axios.get(myUrl + `core/product/info/${app_id}/`, {
                    params: {
                        keyword: 'picture'
                    }
                }).then((res) => {
                    console.log(res);
                    if (res.data.result) {
                        console.log(res.data.data.app_picture.images);
                    } else {
                        // 错误提示
                        this.options = {
                        msgIsSuccess: false,
                        msgText: res.data.message
                        }
                    }
                })

            }
        },
        created() {
            if(this.$route.params.wid) {
                this.getImagesList();
            }
            
        }
    }
</script>
<style media="screen" lang="scss" scoped>
    @import '../../../../css/cropper.min.css';
    @import '../../../../css/daterangepicker.css';
    .works-picture {
        width: 100%;
        .works {
            display: table;
        }
        .works-wrapper {
            padding: 40px;
            display: inline-block;
            float: left;
            &.upload-works {
                font-size: 12px;
                color: #a6a6a6;
                line-height: 20px;
                h2 {
                    font-size: 16px;
                    color: #4f515e;
                    line-height: 32px;
                }
                .upload-works-list {
                    width: 100%;
                    display: table;
                    margin-bottom: 12px;
                    li {
                        cursor: pointer;
                        position: relative;
                        width: 270px;
                        height: 170px;
                        float: left;
                        border: dashed 1px #e6e6e7;
                        background: #fafafa;
                        &:nth-child(2) {
                            margin: 0 10px;
                        }
                        input[type=file]{
                            cursor: pointer;
                            position: absolute;
                            top: 0;
                            width: 100%;
                            height: 100%;
                            opacity: 0;
                        }
                    }
                }
            }
        }
        .upload-logo {
            width: 329px;
            height: 262px;
            font-size: 12px;
            color: #a6a6a6;
            line-height: 20px;
            h2 {
                font-size: 16px;
                color: #4f515e;
                line-height: 32px;
            }
            .upload-logo-box {
                width: 60px;
                height: 60px;
                position: relative;
                margin-bottom: 12px;
                cursor: pointer;
                input[type="file"] {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 60px;
                    height: 60px;
                    opacity: 0;
                    appearance: none;
                    -webkit-appearance: none;
                    cursor: pointer;
                }
                .upload-logo-file {
                    position: absolute;
                    width: 60px;
                    height: 60px;
                    cursor: pointer;
                    border: dashed 1px #e6e6e7;
                    background: #fafafa;
                    display: table;
                    text-align: center;
                    span {
                        display: table-cell;
                        vertical-align: middle;
                    }
                }
            }
        }
    }
    .upload-works-detail {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        img {
            width: 100%;
            height: 100%;
        }
        .icon-error {
          z-index: 999;
          position: absolute;
          right: 5px;
          top: 5px;
          display: inline-block;
          width: 20px;
          height: 20px;
          background: url(../../../../images/common/error.png) no-repeat;
          background-size: cover;
        }
        .text {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 28px;
          line-height: 28px;
          background: rgba(0,0,0,.5);
          padding: 0 15px;
          color: #fff;
          font-size: 14px;
        }
    }
    .mask{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #fafafa;
        /* padding-top: 53px; */
        text-align: center;
        color: #b4b4b4;
        cursor: pointer;
        display: table;
        .mask-box {
            display: table-cell;
            vertical-align: middle;
        }
        .text{
            margin-top: 10px;
            font-size: 14px;
        }
    }
    .mask-loading{
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.5);
        text-align: center;
        color: #fff;
        cursor: pointer;
        .loading-box{
            position:absolute;
            top:50%;
            left:50%;
            transform:translate(-50%,-50%);
        }
        .loading {
            width: 3px;
            height: 40px;
            position: relative;
            margin: 0 auto;
            .strip{
                width: 100%;
                height: 90%;
                position: absolute;
                &:before{
                content: '';
                display: block;
                margin: 0 auto;
                width: 100%;
                height: 26%;
                background-color: #fff;
                border-radius:6px 6px 0 0;
                animation: stripFadeDelay 1.2s infinite ease-in-out both;
                }
            }
            .strip2 { transform: rotate(30deg);}
            .strip3 { transform: rotate(60deg);}
            .strip4 { transform: rotate(90deg);}
            .strip5 { transform: rotate(120deg);}
            .strip6 { transform: rotate(150deg);}
            .strip7 { transform: rotate(180deg);}
            .strip8 { transform: rotate(210deg);}
            .strip9 { transform: rotate(240deg);}
            .strip10 { transform: rotate(270deg);}
            .strip11 { transform: rotate(300deg);}
            .strip12 { transform: rotate(330deg);}
            .strip2:before {animation-delay: -1.1s; }
            .strip3:before { animation-delay: -1s; }
            .strip4:before { animation-delay: -0.9s; }
            .strip5:before { animation-delay: -0.8s; }
            .strip6:before { animation-delay: -0.7s; }
            .strip7:before { animation-delay: -0.6s; }
            .strip8:before { animation-delay: -0.5s; }
            .strip9:before { animation-delay: -0.4s; }
            .strip10:before { animation-delay: -0.3s; }
            .strip11:before { animation-delay: -0.2s; }
            .strip12:before { animation-delay: -0.1s; }
            @-webkit-keyframes stripFadeDelay {
                0%, 39%, 100% { opacity: 0.5; }
                40% { opacity: 1; }
            }

            @keyframes stripFadeDelay {
                0%, 39%, 100% { opacity: 0.5; }
                40% { opacity: 1; }
            }
        }
    }
    .product-img{
        width:285px;
        height: 160px;
        position: relative;
        float: left;
        border: dashed 1px #e6e6e7;
        overflow: hidden;
        >img{
            width: 100%;
            height: 100%;
        }
        /* &:hover{
            .mask{
                background: rgba(0,0,0,.7);
            }
        } */
        input[type=file]{
            cursor: pointer;
            position: absolute;
            top: 0;
            width: 285px;
            height: 160px;
            opacity: 0;
        }
        .icon-error {
          cursor: pointer;
        }
    }
    .artwork-cover{
        width: 217px;
        float: right;
        font-size: 12px;
        color: #a6a6a6;
        line-height: 20px;
        padding-left: 18px;
        h2 {
            font-size: 16px;
            color: #4f515e;
            line-height: 32px;
        }
    }
    .personal-pops{
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background: rgba(0,0,0,.3);
        z-index: 10000;
        .pops-content{
            width: 853px;
            height: 60%;
            padding: 20px 24px;
            background: #fff;
            position: absolute;
            left: 50%;
            top:50%;
            transform:translate(-50%,-50%);
            h4{
                font-size: 16px;
                color: #090b1a;
            }
            .confirm-image-editor{
                width: 80px;
                height: 30px;
                background: #5bd18b;
                color: #fff;
                font-size: 16px;
                text-align: center;
                line-height: 20px;
                border-radius: 3px;
                display: inline-block;
                margin-top: 20px;
                border: none;
                box-shadow: none;
                outline: none;
            }
            .editor{
                height: 70%;
                margin-top: 30px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
    .border-bottom {
        border-bottom: solid 1px #f4f4f4;
    }
    .border-right {
        border-right: solid 1px #f4f4f4;
    }
    .bk-personal_center{
    .btn-save{
      &:hover{
        color: #fff;
      }
    }
    .btn-row{
      position: absolute;
      width: calc(100% - 40px);
      bottom: 20px;
      text-align: right;
    }
    .btn{
      padding: 4px 9px;
      margin-top: 20px;
      color: #fff;
      background: #a474f3;
      position: relative;
      -webkit-box-flex: 0;
      -webkit-flex: 0 1 auto;
      -ms-flex: 0 1 auto;
      flex: 0 1 auto;
      outline:none;
      &:hover{
        background: #8d4ff3;
      }
    }
    .confirm-image-editor{
        width: 80px;
        height: 30px;
        background: #5bd18b;
        color: #fff;
        font-size: 16px;
        text-align: center;
        line-height: 20px;
        border-radius: 3px;
        display: inline-block;
        margin-top: 20px;
        border: none;
        box-shadow: none;
        outline: none;
    }
    .editor{
        height: 70%;
        margin-top: 30px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .personal-info{
      .personal-pops{
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background: rgba(0,0,0,.3);
        z-index: 10000;
        .pops-content{
          width: 853px;
          height: 60%;
          padding: 20px 24px;
          background: #fff;
          position: absolute;
          left: 50%;
          top:50%;
          transform:translate(-50%,-50%);
          h4{
            font-size: 16px;
            color: #090b1a;
          }
        }
      }
    }
    select{
      outline: inherit;
    }
    select{
      &.form-control{
        width: 100%;
        padding-left: 7px;
        padding-right: 7px;
        box-shadow: none;
        border-radius: 0;
        border-color: #e6e6e7;
      }
    }
  }
  .upload-mask {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      margin: auto;
      background: rgba(0, 0, 0, 0.5);
      padding-top: 53px;
      text-align: center;
      color: #fff;
      cursor: pointer;
      .text {
          margin-top: 10px;
      }
  }
</style>



// WEBPACK FOOTER //
// works_pictures.vue?22a68bd1